import {FormControl, FormField} from 'platform/components';
import {Hide} from 'platform/foundation';

import {useWatch} from 'react-hook-form';

import {OrderResponseBody} from '@dms/api/finance';
import i18n from '@dms/i18n';
import {useBank} from '@dms/shared';

import {TestIdProps, suffixTestId} from 'shared/web';

import {FormValuesType} from '../types/FormValuesType';

type BankAccountOptions = ReturnType<typeof useBank>['salesBankAccountOptions'];

interface TenantBankAccountFieldProps extends TestIdProps {
  control: FormControl<FormValuesType>;
  order: OrderResponseBody;
  bankAccountOptions: BankAccountOptions;
  /** Offers the seller's accounts, which the seller does not have to have (mode 2). */
  isSellerAsSupplier?: boolean;
}

export function TenantBankAccountField(props: TenantBankAccountFieldProps) {
  const paymentMethod = useWatch({control: props.control, name: 'paymentMethod'});
  const isRequiredBankAccount = paymentMethod !== 'CASH_ON_DELIVERY' && !props.isSellerAsSupplier;
  // In mode 2 the seller is the supplier on the issued documents.
  const label = props.isSellerAsSupplier
    ? i18n.t('entity.warehouse.labels.supplierAccount')
    : i18n.t('entity.checkout.labels.dealerBankAccount');

  return (
    <Hide
      when={
        props.order.orderDiscriminator === 'PURCHASE' ||
        props.order.orderDiscriminator === 'PURCHASE_BROKERAGE_SALE'
      }
    >
      <FormField
        name="tenantBankAccount"
        type="choice"
        control={props.control}
        options={props.bankAccountOptions}
        isNotClearable={!props.isSellerAsSupplier}
        label={label}
        isRequired={isRequiredBankAccount}
        data-testid={suffixTestId('dealerBankAccount', props)}
      />
    </Hide>
  );
}
